// frontend/src/pages/Sabesp/components/WorkspaceSelector.js
import React, { useState, useEffect } from "react";

export default function WorkspaceSelector({ groups, activeGroupId, onSelect, onCreateGroup, onManage }) {
  const [open, setOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState("");
  const [createError, setCreateError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const active = groups.find((g) => g.id === activeGroupId);

  useEffect(() => {
    if (!open) {
      setCreating(false);
      setNewName("");
      setCreateError(null);
    }
  }, [open]);

  async function submitCreate() {
    const trimmed = newName.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setCreateError(null);
    try {
      await onCreateGroup(trimmed);
      setOpen(false);
    } catch (err) {
      setCreateError(err.message || "Não foi possível criar o grupo.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="sabesp-workspace-selector">
      <button className="sabesp-workspace-capsule" onClick={() => setOpen((v) => !v)}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
        </svg>
        <span className="sabesp-workspace-label">{active ? active.name : "NTS Oficial"}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      {open && (
        <div className="sabesp-workspace-dropdown">
          <div
            className={`sabesp-workspace-option${!activeGroupId ? " active" : ""}`}
            onClick={() => {
              onSelect(null);
              setOpen(false);
            }}
          >
            NTS Oficial
          </div>
          {groups.map((g) => (
            <div
              key={g.id}
              className={`sabesp-workspace-option${g.id === activeGroupId ? " active" : ""}`}
              onClick={() => {
                onSelect(g.id);
                setOpen(false);
              }}
            >
              <span>{g.name}</span>
              <button
                className="sabesp-workspace-manage-btn"
                title="Gerenciar grupo"
                onClick={(e) => {
                  e.stopPropagation();
                  onManage(g.id);
                  setOpen(false);
                }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                </svg>
              </button>
            </div>
          ))}
          {creating ? (
            <div className="sabesp-workspace-create-form">
              <input
                autoFocus
                className="sabesp-workspace-create-input"
                placeholder="Nome do grupo"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submitCreate()}
                disabled={submitting}
              />
              <button
                className="sabesp-workspace-create-confirm"
                onClick={submitCreate}
                disabled={submitting || !newName.trim()}
              >
                {submitting ? "..." : "Criar"}
              </button>
            </div>
          ) : (
            <div className="sabesp-workspace-option sabesp-workspace-create" onClick={() => setCreating(true)}>
              + Criar grupo
            </div>
          )}
          {createError && <div className="sabesp-workspace-create-error">{createError}</div>}
        </div>
      )}
    </div>
  );
}
